import { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import { useConfigContext } from 'store';

const defaultAxiosConfig = {
    headers: {
        'X-From-Channel': 'rentcar-backstage',
        'X-Client-TraceId': uuid(),
        'X-Client-Date': moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    },
    method: 'POST'
};

const storageKeys = {
    idToken: 'idToken',
    city: 'city'
};

const getIsTokenValid = (token) => {
    // 如果已經有 idToken
    if (token) {
        const decode = jwtDecode(token);
        const exp = decode.exp * 1000 - Date.now();
        if (exp > 1000 * 60) {
            // 檢查 token 時間，還沒過期的話直接回 idToken
            return true;
        }
    }
    return false;
};

export const useLoginService = () => {
    const { loginApiUrl, apiUrl } = useConfigContext();

    const postLoginHandler = useCallback(async (recaptchaToken, body) => {
        const requestConfig = {
            ...defaultAxiosConfig,
            baseURL: loginApiUrl,
            url: '/login',
            data: body
        };
        requestConfig.headers['X-Recaptcha-Auth'] = recaptchaToken;
        const res = await axios(requestConfig);
        return res.data;
    }, [loginApiUrl]);

    const postSmsCodeHandler = useCallback(async (token, body) => {
        const requestConfig = {
            ...defaultAxiosConfig,
            baseURL: apiUrl,
            url: '/sms-code',
            data: body
        };
        requestConfig.headers.Authorization = `Bearer ${token}`;
        const res = await axios(requestConfig);
        return res.data;
    }, [apiUrl]);

    const postLogin = useCallback(async (recaptchaToken, body) => (
        postLoginHandler(recaptchaToken, body)
    ), [postLoginHandler]);

    const postSmsCode = useCallback(({ id, token, smsCode }) => (
        postSmsCodeHandler(token, { id, smsCode })
    ), [postSmsCodeHandler]);

    return {
        postLogin,
        postSmsCode,
        getIsTokenValid,
        storageKeys
    };
};
